import React from "react";
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Checkbox, FormControlLabel } from "@material-ui/core";

const EditVendor = ({ onSave, setOpen, label, open, id, vendor }) => {
    const [name, setName] = React.useState(vendor?.name);
    const [includeFmc, setIncludeFmc] = React.useState(!!vendor?.includeFmc);

    const handleClose = () => {
        setName("");
        setOpen(false);
    };

    const handleSave = async () => {
        await onSave({ id, name, includeFmc });
        handleClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">{label}</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    margin="dense"
                    label="Name"
                    fullWidth
                    value={name}
                    onChange={e => setName(e.target.value)}
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={includeFmc}
                            onChange={(e, value) => setIncludeFmc(value)}
                        />
                    }
                    label={<div>Include Client Name</div>}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleSave} color="primary" variant="contained">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};


export default EditVendor;
